export default class FeeTax {
  constructor({
    taxAmount = {
      amount: '',
      currency: '',
    },
    taxCode = '',
  }) {
    this.taxAmount = taxAmount;
    this.taxCode = taxCode;
  }
}